export default class formConfig {
  // 项目信息
  static projectInformation() {
    return [
      {
        title: "发包人及项目信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "报建编号：",
            value: "constructionNo",
            type: "input",
            width: "100%",
            disabled: true
          },
          {
            type: "select",
            label: "备案部门：",
            value: "regulators",
            width: "100%",
            placeholder: "请输入",
            disabled: true,
            queryParams: {
              url: "/regulatorsCombobox",
              processType: "201705121618210002"
            }
          },
          {
            label: "工程名称：",
            value: "prjName",
            type: "input",
            width: "100%",
            maxlength: 300,
            disabled: true
          },
          {
            type: "select",
            label: "备案项目类别：",
            value: "tenderClassNum",
            width: "100%",
            clearable: true,
            disabled: true,
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201510200918460003"
            }
          },
          {
            type: "select",
            label: "备案项目内容：",
            value: "tenderContentNum",
            width: "100%",
            placeholder: "请输入",
            disabled: true,
            queryParams: {}
          },
          {
            label: "建设单位：",
            value: "buildCorp",
            type: "input",
            width: "100%",
            disabled: true
          },
          {
            label: "公司经济类型：",
            value: "economicType",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "建设用地取得方式：",
            value: "buildingLandObtained",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "建设单位法人代表：",
            value: "corpLegal",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "建设单位法人授权委托人：",
            value: "linkMan",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "授权委托人电话：",
            value: "linkTel",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "项目批准机构：",
            value: "recordUnitName",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "工程地点：",
            value: "projectSite",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "批文名称：",
            value: "approvalName",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "立项批准文号：",
            value: "noteNumber",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "资金来源：",
            value: "fundsSources",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "资金性质：",
            value: "fundsCharacter",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "资金来源落实情况：",
            value: "situation",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "房屋建筑工程建筑面积（ ㎡）：",
            value: "constructionArea",
            type: "input",
            slotName: "constructionArea",
            width: "50%",
            disabled: true
          },
          {
            label: "结构层次：",
            value: "structuralHierarchy",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "市政工程规模：",
            value: "municipalProjectScale",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            disabled: true
          },
          {
            label: "其它工程规模：",
            value: "otherProjectScale",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            disabled: true
          }
        ]
      }
    ];
  }
  // 施工单位信息
  static constructionUnitrmation() {
    return [
      {
        title: "施工单位信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "施工单位：",
            value: "constructionUnitName",
            type: "input",
            width: "100%",
            disabled: true
          },
          {
            label: "施工单位确认时间：",
            value: "constructionSealDate",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "企业资质类别及等级：",
            value: "qualificationCategories",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "项目负责人：",
            value: "projectManagerName",
            type: "input",
            width: "100%",
            disabled: true
          },
          {
            label: "执业资格类别等级及编号：",
            value: "qualificationCategoryLevel",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "项目负责人安全生产考核合格证书编号：",
            value: "managerCertificateNumber",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "专职安全生产管理人员姓名：",
            value: "managementCertificateName",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "专职安全生产管理人员安全生产考核合格证书编号：",
            value: "managementCertificateNumber",
            class: "managementCertificateNumber",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "计划工期（日历天）：",
            value: "planTimeLimit",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "工程造价（万元）：",
            value: "projectCost",
            type: "input",
            width: "50%",
            disabled: true
          }
        ]
      }
    ];
  }
  // 监理单位信息
  static superUnitrmation() {
    return [
      {
        title: "监理单位信息",
        name: "1",
        icon: "",
        tipsList: [{ text: "填写说明：必须输入项如没有可填“无”。" }],
        formConfigList: [
          {
            label: "监理单位：",
            value: "superUnitName",
            type: "input",
            width: "100%",
            disabled: true
          },
          {
            label: "监理单位确认时间：",
            value: "superSealDate",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "企业资质类别及等级：",
            value: "superQualificationCategories",
            width: "50%",
            type: "input",
            disabled: true
          },
          {
            label: "项目负责人：",
            value: "superProjectManagerName",
            type: "input",
            width: "100%",
            disabled: true
          },
          {
            label: "执业资格类别等级及编号：",
            value: "superQualificationCategoryLevel",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "项目负责人安全生产考核合格证书编号：",
            value: "superManagerCertificateNumber",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "专职安全生产管理人员姓名：",
            value: "superManagementCertificateName",
            width: "100%",
            type: "input",
            disabled: true
          },
          {
            label: "专职安全生产管理人员安全生产考核合格证书编号：",
            value: "superManagementCertificateNumber",
            width: "100%",
            class: "managementCertificateNumber",
            type: "input",
            disabled: true
          },
          {
            label: "计划工期（日历天）：",
            value: "superPlanTimeLimit",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "工程造价（万元）：",
            value: "superProjectCost",
            type: "input",
            width: "50%",
            disabled: true
          }
        ]
      }
    ];
  }
  // 其他单位信息
  static constructionOtherUnitmation() {
    return [
      {
        title: "其他单位信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "勘察单位：",
            value: "econUnitName",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "勘察单位项目负责人：",
            value: "econProjectManagerName",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "勘察工程造价（万元）：",
            value: "econProjectCost",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "勘察单位确认时间：",
            value: "econSealDate",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "设计单位：",
            value: "designUnitName",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "设计单位项目负责人：",
            value: "designProjectManagerName",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "设计工程造价（万元）：",
            value: "designProjectCost",
            type: "input",
            width: "50%",
            disabled: true
          },
          {
            label: "设计单位确认时间：",
            value: "designSealDate",
            type: "input",
            width: "50%",
            disabled: true
          }
          // {
          //   label: "监理单位：",
          //   value: "superUnitName",
          //   type: "input",
          //   width: "50%",
          //   disabled: true
          // },
          // {
          //   label: "监理单位项目负责人：",
          //   value: "superProjectManagerName",
          //   type: "input",
          //   width: "50%",
          //   disabled: true
          // },
          // {
          //   label: "监理工程造价（万元）：",
          //   value: "superProjectCost",
          //   type: "input",
          //   width: "50%",
          //   disabled: true
          // },
          // {
          //   label: "监理单位确认时间：",
          //   value: "superSealDate",
          //   type: "input",
          //   width: "50%",
          //   disabled: true
          // }
        ]
      },
      {
        title: "联合体单位信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "是否联合体：",
            value: "isUnion",
            type: "select",
            clearable: true,
            disabled: true,
            optionData: [
              { name: "是", value: "1" },
              { name: "否", value: "0" }
            ]
          },
          {
            type: "slot",
            class: "formList",
            slotName: "unionList"
          }
        ]
      },
      {
        title: "联合体协议扫描件",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "扫描件：",
            type: "slot",
            slotName: "uploadUnionFile"
          }
        ]
      }
    ];
  }
  // 其他信息
  static otherInformation() {
    return [
      {
        title: "发包范围",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "发包范围：",
            value: "contractScope",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            disabled: true
          }
        ]
      },
      {
        title: "工程施工单位项目管理机构配备情况",
        name: "2",
        icon: "",
        formConfigList: [
          {
            type: "slot",
            slotName: "organizationAllocationinfoList",
            class: "list",
            width: "100%"
          }
        ]
      },
      {
        title: "备注",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "备注：",
            value: "remarks",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            disabled: true
          }
        ]
      }
    ];
  }
}
